import { render, staticRenderFns } from "./NotSubmitOrderInfo.vue?vue&type=template&id=38bef4ca&scoped=true&"
import script from "./NotSubmitOrderInfo.vue?vue&type=script&lang=js&"
export * from "./NotSubmitOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./NotSubmitOrderInfo.vue?vue&type=style&index=0&id=38bef4ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bef4ca",
  null
  
)

export default component.exports